(() => {
  if (customElements.get('rednib-instagram-consent')) return;

  class InstagramConsent extends HTMLElement {
    connectedCallback() {
      this.feed = this.querySelector('[data-feed]');
      this.placeholder = this.querySelector('[data-placeholder]');
      this.status = this.querySelector('[data-status]');
      this.allowed = false;
      this.sync = this.sync.bind(this);
      this.openPreferences = this.openPreferences.bind(this);
      this.querySelector('[data-preferences]').addEventListener('click', this.openPreferences);
      document.addEventListener('visitorConsentCollected', this.sync);
      window.addEventListener('pageshow', this.sync);
      this.timer = window.setInterval(this.sync, 500);
      this.sync();
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      document.removeEventListener('visitorConsentCollected', this.sync);
      window.removeEventListener('pageshow', this.sync);
      this.querySelector('[data-preferences]').removeEventListener('click', this.openPreferences);
      this.feed.replaceChildren();
    }

    hasConsent() {
      try {
        const api = window._iub?.cs?.api;
        return api?.isPreferenceExpressed() === true && api.getPreferences()?.purposes?.['3'] === true;
      } catch {
        return false;
      }
    }

    sync() {
      const allowed = this.hasConsent();
      if (allowed === this.allowed) return;
      this.allowed = allowed;
      if (!allowed) {
        this.feed.replaceChildren();
        this.feed.hidden = true;
        this.placeholder.hidden = false;
        this.status.textContent = '';
        return;
      }
      this.renderPosts();
    }

    openPreferences() {
      const api = window._iub?.cs?.api;
      if (typeof api?.openPreferences === 'function') api.openPreferences();
    }

    safeUrl(value, image = false) {
      try {
        const url = new URL(value);
        const host = url.hostname.toLowerCase();
        const valid = image
          ? host.endsWith('.cdninstagram.com') || host.endsWith('.fbcdn.net')
          : host === 'www.instagram.com' || host === 'instagram.com';
        return url.protocol === 'https:' && valid ? url.href : null;
      } catch {
        return null;
      }
    }

    renderPosts() {
      const template = this.querySelector('[data-media]');
      const posts = [];
      template.content.querySelectorAll('script').forEach(script => {
        const match = script.textContent.match(/\bconst\s+mf\s*=\s*(\[[\s\S]*?\]);/);
        if (!match) return;
        try {
          const data = JSON.parse(match[1]);
          if (Array.isArray(data)) posts.push(...data);
        } catch { }
      });
      const fragment = document.createDocumentFragment();
      for (const post of posts.slice(0, 12)) {
        const imageUrl = this.safeUrl(post.mediaType === 'VIDEO' ? post.thumbnailUrl : post.mediaUrl, true);
        const href = this.safeUrl(post.permalink);
        if (!imageUrl || !href) continue;
        const link = document.createElement('a');
        link.href = href;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        const image = document.createElement('img');
        image.alt = post.caption?.slice(0, 180) || this.dataset.postLabel;
        image.width = 600;
        image.height = 600;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.referrerPolicy = 'no-referrer';
        image.src = imageUrl;
        link.append(image);
        fragment.append(link);
      }
      if (!fragment.childElementCount) {
        this.status.textContent = this.dataset.unavailable;
        return;
      }
      this.feed.replaceChildren(fragment);
      this.feed.hidden = false;
      this.placeholder.hidden = true;
      this.status.textContent = '';
    }
  }

  customElements.define('rednib-instagram-consent', InstagramConsent);
})();
